import headerring from '../../assets/img/headerRing.png'

export function SectionHeader({title}:{title: string}) {
    return (
        <div
            className="sectionHeader"
        >
            <h2>{title}</h2>
            <img 
                src={headerring} 
                alt={title} 
            />
        </div>
    )
}

export function IconHeader({title, Icon}:{title: string, Icon:any}){



    return(

        <span className="font-semibold leading-1">

            <div
                className="align self-center mr-1 w-8"
            >
                <Icon />
            </div>
            <h1 className="primary text-xl font-semibold">
                {title}
            </h1>
            
        </span>

    )

}